module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Anchor-center-up-1db8f5d3996ebf6a13b4d82ce58abc67.svg";